import(/* webpackMode: "eager", webpackExports: ["GrowthPageView"] */ "/app/apps/platform-web/components/seo/GrowthPageView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TalentAppShell"] */ "/app/apps/platform-web/components/talent/app/TalentAppShell.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
